import * as React from 'react';
import { useMediaQuery } from '../hooks';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Image from '../Image/Image';
import Text from '../Text/Text';

export interface Props extends FlexProps {}

/**
 * A composite component used as a placeholder page for when there
 * is a 500 server error.
 */
const Status500: React.FunctionComponent<Props> = (props: Props) => {
  const match = useMediaQuery(['65rem']);

  return (
    <Flex { ...props } alignChildrenHorizontal="middle" direction="vertical" paddingHorizontal="x6">
      <Flex
          alignChildren="middle"
          direction={ match('65rem') ? 'horizontal' : 'vertical' }
          gap={ match('65rem') ? 'x8' : 'x4' }>
        <Text align="middle" config="1">
          500
        </Text>
        <Text align="middle" config="3">
          Something went wrong
        </Text>
      </Flex>

      <Text align="middle" letterSpacing="x2" margin="x5" size="x4">
        Everything is under control, we will be back soon. Until then keep refreshing your browser.
      </Text>

      <Image margin="x16" src="https://bitrise-bitkit.s3.us-east-2.amazonaws.com/assets/Status500.svg" />
    </Flex>
  );
};

export default Status500;
